module.exports = __webpack_public_path__ + "img/behold-8.12a2f4e6.png";